import { render } from "./ProductCardSuper.vue?vue&type=template&id=f6d10546&scoped=true"
import script from "./ProductCardSuper.vue?vue&type=script&lang=js"
export * from "./ProductCardSuper.vue?vue&type=script&lang=js"

import "./ProductCardSuper.vue?vue&type=style&index=0&id=f6d10546&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6d10546"]])

export default __exports__